export default {
    FETCH_PAYMENT_PLAN_ERROR: "fetch_payment_plan_error",
    ACCEPT_OFFER_ERROR: "accept_offer_error",
    ACCEPT_OFFER_VALIDATION_ERROR: "accept_offer_validation_error",
    ACCEPT_OFFER_SOFT_ERROR: "accept_offer_soft_error"
}
